import { Component } from '@angular/core';

@Component({
    selector: 'app-awaiting-verification',
    templateUrl: './awaiting-verification.component.html',
    styleUrls: ['./awaiting-verification.component.scss']
})
export class AwaitingVerificationComponent {}
